import { FormDataGroup } from 'src/types';

export const leadsMasInformacionPartialData = (isConfigure?: boolean, isDealer?: boolean): Partial<FormDataGroup> => ({
	headers: { FORM_OBJECTIVE: 'Más Información' },
	fields: {
		formFields: {},
		formularioFlag: 'masInformacion',
		formName: isConfigure ? 'lead-mas_informacion-configure' : isDealer ? 'lead-mas_informacion-dealer' : 'lead-mas_informacion',
		formType: 'contact',
		pageCategory: 'Más Información',
	},
});
